import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Table, Button, Rate, Drawer } from 'antd';
import moment from 'moment';
import classNames from 'classnames';

import { pageChanged, voteChatlog } from '../../../../../data/redux/page_details/actions';
import { getAllIntents } from '../../../../../data/redux/nlp_details/actions';
import * as feedbackActions from '../../../../../data/redux/feedback_details/actions';
import { APP_PAGES, ORIENTATION } from '../../../../../data/config/constants';
import { uniqueId } from '../../../../../data/config/utils';

import ProfileAvatar from '../../../../../components/profileavatar';
import CustomHeader from '../../../../../components/customheader';
import ErrorBoundary from '../../../../../components/errorboundary';
import PageHeaderLoader from '../../../../../components/pageheader/loaders';
import CardRowTableLoader from '../../../components/loaders/cardrowtable';
import ShowMessage from '../../../../../components/showmessage';
import FeedbackChatlog from './feedbackchatlog';

class Feedback extends Component {
  constructor(props) {
    super(props);
    this.state = {
      drawer_data: {
        show_feedback_chatlog: false,
      }
    };
    this.columns = this.getFeedbackTableColumns();
  }

  componentWillMount() {
    this.props.actions.pageChanged(APP_PAGES.FEEDBACK, APP_PAGES.ANALYTICS);
  }

  componentDidMount() {
    const { actions, feedback_details } = this.props;
    const payload = {
      startDate: feedback_details.filters.date_range[0],
      endDate: feedback_details.filters.date_range[1],
    };
    actions.getAllFeedback(payload);
    actions.getAllIntents();
  }

  getFeedbackTableColumns = () => {
    const columns = [
      {
        title: 'Date',
        dataIndex: 'createdAt',
        key: 'createdAt',
        sorter: (t1, t2) => t1.createdAt - t2.createdAt,
        render: timestamp => <span>{moment(timestamp).format('DD MMM YYYY')}</span>
      },
      {
        title: 'User Name',
        dataIndex: 'sessionDetails.udf1',
        key: 'sessionDetails.udf1',
        render: (text, record) => <span className="ori-capitalize">{record.sessionDetails.udf1 && record.sessionDetails.udf1.trim().length > 0 ? record.sessionDetails.udf1 : "Unknown"}</span>
      },
      {
        title: "Rating",
        key: "rating",
        dataIndex: "rating",
        sorter: (t1, t2) => { if (t1.rating > t2.rating) return 1; else return -1; },
        render: rating => { return (<Rate allowHalf disabled defaultValue={rating} />); }
      },
      {
        title: "Comments",
        key: "comments",
        dataIndex: "comments"
      },
      {
        title: "Action",
        key: "action",
        dataIndex: "action",
        align: 'center',
        render: (text, record) => {
          return (
            <Button type="primary" size="small" className="ori-border-radius-15 ori-lr-pad-10 ori-font-xs" onClick={() => this.handleViewChatlog(record)}>View More</Button>
          );
        }
      }
    ];
    return columns;
  };

  handleFeedbackDateRangeChange = date_range => {
    const { actions } = this.props;
    const payload = {
      startDate: date_range[0],
      endDate: date_range[1],
    };
    actions.getAllFeedback(payload);
    actions.updateFeedbackState(date_range, "filters.date_range");
  };

  handleCloseDrawer = () => {
    const { actions } = this.props;
    this.setState({
      drawer_data: {
        show_feedback_chatlog: false
      }
    });
    actions.updateFeedbackState([], "active_feedback_data.messages");
    actions.updateFeedbackState({}, "active_feedback_data.active_feedback_item");
  };

  handleViewChatlog = record => {
    const { actions } = this.props;
    const payload = { sessionId: record.sessionId };
    actions.getFeedbackChatlog(payload, () => {
      this.setState({
        drawer_data: {
          ...this.state.drawer_data,
          show_feedback_chatlog: true
        }
      });
      actions.updateFeedbackState(record, "active_feedback_data.active_feedback_item");
    });
  };

  render() {
    const { screen_width, screen_orientation, feedback_details } = this.props;
    const { drawer_data } = this.state;
    const drawer_width = (screen_width < 480 || (screen_width >= 480 && screen_width < 768 && screen_orientation === ORIENTATION.LANDSCAPE)) ? screen_width : 450;

    if (feedback_details.loaders.feedback_loading && !feedback_details.loaders.feedback_loaded) {
      return (
        <div className="ori-full-parent-height oriBotMessagesContainer">
          <PageHeaderLoader container_class="ori-lr-pad-10" bottom_bordered />
          <div className="ori-pad-10">
            <CardRowTableLoader />
          </div>
        </div>
      );
    } else if (!feedback_details.loaders.feedback_loading && feedback_details.loaders.feedback_loaded) {
      const title = feedback_details.active_feedback_data.active_feedback_item && feedback_details.active_feedback_data.active_feedback_item.sessionDetails && feedback_details.active_feedback_data.active_feedback_item.sessionDetails.udf1 ? feedback_details.active_feedback_data.active_feedback_item.sessionDetails.udf1 : "unknown";
      const avatar_bg_class = { "ori-bg-primary": true };
      const timestamp = feedback_details.active_feedback_data.active_feedback_item && feedback_details.active_feedback_data.active_feedback_item.sessionDetails && feedback_details.active_feedback_data.active_feedback_item.sessionDetails.lastMessageTimeStamp ? feedback_details.active_feedback_data.active_feedback_item.sessionDetails.lastMessageTimeStamp : null;

      return (
        <div className="ori-lr-pad-10 oriFeedbackContainer">
          <CustomHeader title="feedback" date_range={feedback_details.filters.date_range} onChangeDateRange={this.handleFeedbackDateRangeChange} bottom_bordered show_date_range />
          <div className="ori-tb-pad-10">
            <Table className="ori-card-row-table" rowClassName="ori-bg-white ori-border-radius-4 ori-box-shadow-light" scroll={{ x: 600 }} size={screen_width < 768 ? "small" : "middle"} rowKey={uniqueId} columns={this.columns} dataSource={feedback_details.feedbacks} />
          </div>
          <Drawer className={classNames("ori-drawer ori-drawer-body-with-header", { "ori-drawer-header-no-pad ori-drawer-body-no-pad": drawer_data.show_feedback_chatlog })} width={drawer_width} title={drawer_data.show_feedback_chatlog ? <ProfileAvatar container_class="ori-lr-pad-15 ori-t-pad-15 ori-b-pad-10" title={title} avatar_bg_class={avatar_bg_class} timestamp={timestamp} /> : null} visible={drawer_data.show_feedback_chatlog} placement="right" maskClosable={false} onClose={this.handleCloseDrawer}>
            {
              drawer_data.show_feedback_chatlog &&
              <ErrorBoundary onErrorCallback={this.handleCloseDrawer}>
                <FeedbackChatlog messages={feedback_details.active_feedback_data.messages} active_chat_item={feedback_details.active_feedback_data.active_feedback_item.sessionDetails} button_ok_text="close" handleOkClick={this.handleCloseDrawer} />
              </ErrorBoundary>
            }
          </Drawer>
        </div>
      );
    } else if (!feedback_details.loaders.feedback_loading && !feedback_details.loaders.feedback_loaded) {
      return (
        <ShowMessage title="Error" message="unable to load feedback data. please check your intenet connection and reload the page." height={150} width={150} error />
      );
    } else {
      return null;
    }
  }
}

const mapStateToProps = state => {
  return {
    screen_width: state.page_details.device_data.screen_width,
    screen_orientation: state.page_details.device_data.screen_orientation,
    feedback_details: state.feedback_details,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators(Object.assign({}, { pageChanged, voteChatlog, getAllIntents }, feedbackActions), dispatch)
  };
};

Feedback.propTypes = {
  actions: PropTypes.object,
  screen_width: PropTypes.number,
  screen_orientation: PropTypes.string,
  feedback_details: PropTypes.object,
  history: PropTypes.object,
  match: PropTypes.object,
};

export default connect(mapStateToProps, mapDispatchToProps, null, { withRef: true })(Feedback);



// WEBPACK FOOTER //
// ./src/app/pagecontainer/modules/analytics/feedback/index.js